module.exports = __webpack_public_path__ + "fonts/pacifico-webfont.5b855903.woff";